import React from 'react'
import { motion } from 'framer-motion'
import {
  HiCurrencyDollar,
  HiCollection,
  HiOutlineClock,
  HiOutlineSearch,
  HiTrendingUp,
} from 'react-icons/hi'
import { Stack, Typography, Box } from '@mui/material'
import Touchable from '@components/Touchable'
import { useSelectedTab, useDevMode } from '@plug-core/state'
import { useGoogleAnalytics } from '@plug-core/providers/GoogleAnalyticsProvider'
import { GAEventName } from '@plug-core/interfaces/googleAnalytics'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@utils/routes'
import classes from './SidebarNavigation.module.scss'
import plugHomeLogo from '@assets/icons/plug-home-logo.png'

const TABS = [
  { icon: HiCurrencyDollar, label: 'home', displayName: 'Home' },
  { icon: HiTrendingUp, label: 'defi', displayName: 'DeFi' },
  { icon: HiCollection, label: 'collections', displayName: 'Collections' },
  {
    icon: HiOutlineClock,
    label: 'transactions',
    displayName: 'Transactions',
  },
  { icon: HiOutlineSearch, label: 'discover', displayName: 'Discover' },
]

const SidebarNavigation = () => {
  const { selectedTab, setSelectedTab } = useSelectedTab()
  const { fireEvent } = useGoogleAnalytics()
  const { devEnabled } = useDevMode()
  const navigate = useNavigate()

  const onTabChange = (index: number) => {
    setSelectedTab(index)
    navigate(ROUTES.HOME)

    fireEvent(GAEventName.PAGE_VIEW, {
      page_title: TABS[index].label,
      page_location: '/home',
    })
  }

  return (
    <Stack 
      className={classes.sidebar}
      height={`calc(100% - ${devEnabled ? 40 : 0}px)`}
    >
      <Box p={3} pb={2} pl={6}>
        <img src={plugHomeLogo} alt="Plug" style={{ height: 32, width: 'auto' }} />
      </Box>
      <Stack spacing={1} p={2} pl={6}>
        {TABS.map(({ icon: Icon, label, displayName }, index) => {
          const selected = index === selectedTab
          return (
            <div
              key={label}
              className={`${classes.navItem} ${selected ? classes.selected : ''}`}
              onClick={() => onTabChange(index)}
            >
              <Touchable>
                <Stack direction="row" alignItems="center" spacing={2} p={1.5}>
                  <Icon size={20} color={selected ? 'white' : 'gray'} />
                  <Typography
                    variant="body2"
                    color={selected ? 'white' : 'text.secondary'}
                    fontWeight={selected ? 600 : 400}
                  >
                    {displayName}
                  </Typography>
                </Stack>
              </Touchable>
            </div>
          )
        })}
      </Stack>
    </Stack>
  )
}

export default SidebarNavigation